import React, { Component } from 'react';

export default class ProfileBottomBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.handleNavChange = this.handleNavChange.bind(this);
    }

    handleNavChange(link) {
        this.props.handleNavChange(link.index, 'view');
    }

    render() {

        let links = this.props.links;
        let options = [];
        let width = 100 / (links.length != 0 ? links.length : 1) + '%';
        for (var i = 0; i < links.length; i++) {

            let color = (links[i].index === this.props.activeIndex ? 'rgba(0, 126, 181, 1)' : 'rgba(0, 0, 0, 0.55)');

            if (links[i].icon === 'goals') {
                options.push((
                    <div className="profile-bottom-bar-icon-container" style={{ width: width }} onClick={this.handleNavChange.bind(null, links[i])}>
                        <div className="profile-bottom-bar-icon-container-inner">
                            <svg className="filler-svg-dark" style={{ fill: color }} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.896 28.896">
                                <polygon points="17.698,0 14.448,4.334 11.198,0 4.948,0 14.448,12.667 23.948,0 		" />
                                <polygon points="17.085,18.009 14.448,12.667 11.811,18.009 5.915,18.865 10.182,23.025 9.175,28.896 14.448,26.125 19.722,28.896 18.714,23.025 22.98,18.865 		" />
                            </svg>
                        </div>
                        <div style={{ color: color }} className="profile-bottom-bar-text">{links[i].label}</div>
                    </div>
                ));
            } else if (links[i].icon === 'contests') {
                options.push((
                    <div className="profile-bottom-bar-icon-container" style={{ width: width }} onClick={this.handleNavChange.bind(null, links[i])}>
                        <div className="profile-bottom-bar-icon-container-inner">
                            <svg className="filler-svg-dark" style={{ fill: color }} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297">
                                <g>
                                    <g>
                                        <path d="M174.691,194.214c0-2.718-2.152-4.382-4.782-3.698c0,0-12.318,3.201-21.409,3.201s-21.409-3.201-21.409-3.201 c-2.63-0.684-4.782,0.98-4.782,3.698v14.329c0,2.718,2.224,4.941,4.941,4.941h42.5c2.718,0,4.941-2.224,4.941-4.941V194.214z" />
                                    </g>
                                    <g>
                                        <path d="M223.615,9.884c0-5.458-4.426-9.884-9.884-9.884H83.269c-5.458,0-9.884,4.426-9.884,9.884v81.539 c0,25.522,7.591,48.754,21.374,65.415c13.874,16.771,32.96,26.008,53.741,26.008c20.781,0,39.867-9.236,53.741-26.008 c13.783-16.661,21.374-39.893,21.374-65.415V9.884z" />
                                    </g>
                                    <g>
                                        <path d="M63.981,111.227c-13.525-5.033-19.753-16.706-19.753-36.111V30.969h18.285V11.202H34.346 c-5.459,0-9.884,4.425-9.884,9.884v54.029c0,32.961,15.788,53.039,44.818,57.729C66.895,125.985,65.109,118.749,63.981,111.227z" />
                                    </g>
                                    <g>
                                        <path d="M83.269,228.31c-5.458,0-9.884,4.425-9.884,9.884v48.923c0,5.458,4.426,9.884,9.884,9.884h130.463 c5.458,0,9.884-4.426,9.884-9.884v-48.923c0-5.459-4.426-9.884-9.884-9.884H83.269z" />
                                    </g>
                                    <g>
                                        <path d="M262.654,11.202h-28.168v19.767h18.285v44.146c0,19.405-6.228,31.078-19.753,36.111 c-1.128,7.522-2.913,14.759-5.299,21.618c29.03-4.69,44.818-24.768,44.818-57.729V21.086 C272.538,15.627,268.113,11.202,262.654,11.202z" />
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div style={{ color: color }} className="profile-bottom-bar-text">{links[i].label}</div>
                    </div>
                ));
            } else {
                options.push((
                    <div className="profile-bottom-bar-icon-container" style={{ width: width }} onClick={this.handleNavChange.bind(null, links[i])}>
                        <div style={{ color: color }} className="profile-bottom-bar-icon-container-inner material-icons">{links[i].icon}</div>
                        <div style={{ color: color }} className="profile-bottom-bar-text">{links[i].label}</div>
                    </div>
                ));
            }
        }

        return (
            <div className="profile-bottom-bar-outer">
                {options}
            </div>
        );
    }
}
